import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';
import { CommonMessages } from 'src/app/shared/messages/messages.enum';

@Component({
  selector: 'app-list-subscription-license',
  templateUrl: './list-subscription-license.component.html',
  styleUrls: ['./list-subscription-license.component.css']
})
export class ListSubscriptionLicenseComponent extends BaseComponent implements OnInit {
  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  companyID = 0;
  selectedCompany: any = '';
  selectedCategory: any = '';
  categoryObj: any = [];
  licenseRows: any = [];
  currentUser;
  getCompanyobj: any = [];
  webCatTotal: number = 0;
  slCatPage = 1;
  slCatLimit = 10;
  slCatSkip = 0;
  slCatord = "asc";
  slCatColname = "license_id";
  constructor(private clientService: ClientService,
    private masterService: MasterService) {
    super();
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));
    if (this.currentUser.admin_customer_id != '0') {
      this.companyID = this.currentUser.admin_customer_id;
      this.selectedCompany = this.companyID;
      this.loadCategories(this.selectedCompany);
      this.getLicenseList();
    }
    if (this.currentUser.admin_customer_id == '0') this.getCompany();
  }
  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data;
      const working = this.bindWorkingCompany(this.getCompanyobj);
      if (working) {
        this.selectedCompany = working;
        this.loadCategories(this.selectedCompany);
        this.getLicenseList();
      }
      this.ngxSpinnerService.hide();
    }, error => {
      console.log(error);
    });
  }
  onCompanyChange(value?: any) {
    if (value !== undefined) {
      this.selectedCompany = value;
    }
    this.selectedCategory = '';
    this.slCatPage = 1;
    this.loadCategories(this.selectedCompany);
    this.getLicenseList();
  }
  loadCategories(companyId) {
    this.categoryObj = [];
    if (!companyId) {
      return;
    }
    this.masterService.getLicenseCategoryList(companyId, 1000, 0, '', 'category_id', 'asc').subscribe(data => {
      if (data.status && data.data && data.data.rows) {
        this.categoryObj = data.data.rows;
      } else {
        this.categoryObj = [];
      }
    }, error => {
      console.log(error);
      this.categoryObj = [];
    });
  }
  onCategoryChange(value?: any) {
    if (value !== undefined) {
      this.selectedCategory = value;
    }
    this.slCatPage = 1;
    this.getLicenseList();
  }
  resetFilters() {
    this.selectedCategory = '';
    this.slCatPage = 1;
    this.slCatSkip = 0;
    if (this.searchText && this.searchText.nativeElement) {
      this.searchText.nativeElement.value = '';
    }
    if (this.companyID == 0) {
      this.selectedCompany = this.bindWorkingCompany(this.getCompanyobj) || '';
      this.loadCategories(this.selectedCompany);
    }
    this.getLicenseList();
  }
  onLimitChange() {
    this.slCatLimit = Number(this.slCatLimit) || 10;
    this.slCatPage = 1;
    this.getLicenseList();
  }
  getLicenseList() {
    let searchTerm = this.searchText && this.searchText.nativeElement ? this.searchText.nativeElement.value : '';
    this.slCatSkip = (this.slCatPage - 1) * this.slCatLimit;
    if (this.selectedCompany !== "") {
      this.ngxSpinnerService.show();
      this.masterService.getLicenseCatalogList(this.selectedCompany, this.slCatLimit, this.slCatSkip, searchTerm, this.slCatColname, this.slCatord, this.selectedCategory).subscribe(data => {
        this.ngxSpinnerService.hide();
        if (data.status) {
          this.licenseRows = data.data.rows || [];
          this.webCatTotal = data.data.total;
        } else {
          this.licenseRows = [];
          this.webCatTotal = 0;
        }
      }, error => { console.log(error); this.ngxSpinnerService.hide(); });
    } else {
      this.licenseRows = [];
      this.webCatTotal = 0;
      this.ngxSpinnerService.hide();
    }
  }
  setOrder(value: string) {
    this.slCatColname = value;
    if (this.slCatord == 'asc') {
      this.slCatord = 'desc';
    } else {
      this.slCatord = 'asc';
    }
    this.getLicenseList();
  }
  editPost(id: any) {
    localStorage.setItem("edit_subscription_license_id", id);
    localStorage.setItem("edit_subscription_license_company_id", this.selectedCompany);
    this.router.navigate(['/corporate/edit-subscription-license']);
  }
  delLicense(event, id) {
    event.preventDefault();
    this.confirmationDialogService.confirm('Please confirm', 'ARE YOU SURE YOU WANT TO DELETE ?', 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.masterService.deleteLicenseCatalog(this.selectedCompany, id).subscribe(data => {
            if (data.status) {
              this.toastrService.success("License deleted successfully");
              this.getLicenseList();
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log(CommonMessages.dialogDismissMessage));
  }
  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    this.ngxSpinnerService.show();
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.slCatSkip = 0;
          this.slCatPage = 1;
        }),
        switchMap(data => this.masterService.getLicenseCatalogList(this.selectedCompany, this.slCatLimit, this.slCatSkip, this.searchText.nativeElement.value, this.slCatColname, this.slCatord, this.selectedCategory))
      )
      .subscribe((res: any) => {
        if (res.status) {
          this.licenseRows = res.data.rows || [];
          this.webCatTotal = res.data.total;
        } else {
          this.licenseRows = [];
          this.webCatTotal = 0;
        }
        this.ngxSpinnerService.hide();
      }, error => {
        this.licenseRows = [];
        this.webCatTotal = 0;
        this.ngxSpinnerService.hide();
      });
  }
}
